import { EntityStore } from 'shared/stores/EntityStore';

class ApplicantChangelogStore extends EntityStore {
	entityPluralEndpoint = 'applicants/changelog';
	constructor() {
		super('applicant-changelog');
	}

	typeOptions = [
		{ text: 'English Level', value: 'englishLevel' },
		{ text: 'Country', value: 'countryId' },
		{ text: 'Seniority', value: 'seniority' },
		{ text: 'Hireability', value: 'hireability' },
		{ text: 'Owner', value: 'ownerId' },
		{ text: 'Source', value: 'sourceId' },
		{ text: 'Compensations', value: 'compensations' },
		{ text: 'Tags', value: 'tags' },
		{ text: 'Compensations', value: 'compensations' },
		{ text: 'Primary Potential Job Role', value: 'primaryPotentialJobRole' },
		{ text: 'Potential Job Roles', value: 'potentialJobRoles' },
		{ text: 'Name', value: 'name' },
		{ text: 'Email', value: 'email' },
		{ text: 'Phone Number', value: 'phoneNumber' },
		{ text: 'LinkedIn', value: 'linkedinUrl' },
		{ text: 'City', value: 'city' },
		{ text: 'Github', value: 'githubUrl' },
		{ text: 'Website', value: 'portfolioUrl' }
	];
}

export const applicantChangelogStore = new ApplicantChangelogStore();
